module.exports = __webpack_public_path__ + "img/9_28.5fad9ae4.png";